import { speed } from "../../utils/dom";

let halfPageHeight = 0;

const calculateHalfPageHeight = () => {
  halfPageHeight = document.documentElement.scrollHeight / 2;
};

const handleScroll = ($button: HTMLElement) => {
  const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollPosition >= halfPageHeight) {
    $button.classList.add("is-active");
  } else {
    $button.classList.remove("is-active");
  }
};

/**
 * Scrolling does not move focus, so send it to the skip link at the top.
 */
const focusTopOfPage = () => {
  const $skipLink = document.querySelector<HTMLElement>(".skiplink");

  if ($skipLink) {
    $skipLink.focus();
    return;
  }

  const $main = document.querySelector<HTMLElement>("#maincontent");

  if (!$main) {
    return;
  }

  if (!$main.hasAttribute("tabindex")) {
    $main.setAttribute("tabindex", "-1");
  }

  $main.focus();
};

const scrollToTop = ($button: HTMLElement) => {
  $button.classList.add("is-active");

  window.scrollTo({
    top: 0,
  });

  focusTopOfPage();

  // Reset scrolling state after scroll completes
  setTimeout(() => {
    handleScroll($button);
  }, speed());
};

const instance = ($button: HTMLElement) => {
  calculateHalfPageHeight();

  // Handle scroll events to show/hide button
  const scrollHandler = () => handleScroll($button);
  window.addEventListener("scroll", scrollHandler);

  // Handle click events to scroll to top
  const clickHandler = () => scrollToTop($button);
  $button.addEventListener("click", clickHandler);

  // Recalculate page height on resize
  window.addEventListener("resize", calculateHalfPageHeight);
};

export default () => {
  const $buttons = document.querySelectorAll<HTMLElement>(".back-to-top");

  if ($buttons.length === 0) {
    return;
  }

  $buttons.forEach(($button) => {
    instance($button);
  });
};
